/* ============================================================================
   MONMOUTH CARDS — MOBILE REMEDIATION BEHAVIOURS
   ============================================================================
   Companion to monmouth-mobile-fixes.css. Everything here is mobile-gated or
   inert on desktop. Loaded with defer.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__mcMobileFixInit) return;
  window.__mcMobileFixInit = true;

  var MOBILE = '(max-width: 1023px)';
  var isMobile = function () { return window.matchMedia(MOBILE).matches; };

  /* ------------------------------------------------------------------------
     1. Measure real header height into --mc-header-h
     Sticky elements (filter bar, account nav) must sit exactly below the
     header. Hardcoding 56px breaks when the announcement bar is dismissed or
     when the header wraps. Measure it instead.
     --------------------------------------------------------------------- */
  function syncHeaderHeight() {
    var header = document.querySelector('.mc-nav, .mc-header, header[role="banner"]');
    var announce = document.querySelector('.mc-announce');
    var h = 0;
    if (header) h += header.getBoundingClientRect().height;
    if (announce && getComputedStyle(announce).position !== 'fixed') {
      /* announcement scrolls away, so it does not offset sticky elements */
    }
    if (h > 0) document.documentElement.style.setProperty('--mc-header-h', Math.round(h) + 'px');
  }
  syncHeaderHeight();
  window.addEventListener('resize', debounce(syncHeaderHeight, 150));
  window.addEventListener('load', syncHeaderHeight);

  /* ------------------------------------------------------------------------
     2. Cookie banner height -> --mc-cookie-h, and body class
     Lets the sticky ATC and the help bubble offset above the banner instead
     of hiding under it (audit GLOB-5 / LOC-M5).
     --------------------------------------------------------------------- */
  function syncCookieBanner() {
    var banner = document.querySelector('.mc-cookie');
    var visible = banner && banner.offsetHeight > 0 &&
                  getComputedStyle(banner).display !== 'none';
    document.body.classList.toggle('mc-cookie-open', !!visible);
    if (visible) {
      document.documentElement.style.setProperty(
        '--mc-cookie-h', Math.round(banner.getBoundingClientRect().height) + 'px');
    } else {
      document.documentElement.style.removeProperty('--mc-cookie-h');
    }
  }
  syncCookieBanner();
  window.addEventListener('resize', debounce(syncCookieBanner, 150));
  var cookieEl = document.querySelector('.mc-cookie');
  if (cookieEl && 'MutationObserver' in window) {
    new MutationObserver(syncCookieBanner)
      .observe(cookieEl, { attributes: true, attributeFilter: ['style', 'class'] });
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.mc-cookie')) setTimeout(syncCookieBanner, 60);
  });

  /* ------------------------------------------------------------------------
     3. Template class on body
     Lets CSS target the PDP for the sticky ATC without a JS check.
     --------------------------------------------------------------------- */
  var tmpl = document.documentElement.getAttribute('data-template') ||
             (document.body.className.match(/template-([a-z0-9_-]+)/) || [])[1];
  if (tmpl) document.body.classList.add('mc-template-' + tmpl);

  /* ------------------------------------------------------------------------
     4. Sticky Add to Cart on mobile PDP                        [PDP-M7]
     Appears when the inline ATC scrolls out of view, hides when it returns.
     Reuses the real form so variant resolution and analytics are unchanged.
     --------------------------------------------------------------------- */
  function initStickyAtc() {
    if (!isMobile()) return;
    if (!document.body.classList.contains('mc-template-product')) return;
    if (document.querySelector('.mc-sticky-atc')) return;

    var inlineBtn = document.querySelector('.mc-pdp__add-btn');
    var form = inlineBtn && inlineBtn.closest('form');
    if (!inlineBtn || !form) return;

    var titleEl = document.querySelector('.mc-pdp__title, h1');
    var priceEl = document.querySelector('.mc-pdp__price');

    var bar = document.createElement('div');
    bar.className = 'mc-sticky-atc';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Add to cart');
    bar.innerHTML =
      '<div class="mc-sticky-atc__info">' +
        '<div class="mc-sticky-atc__title"></div>' +
        '<div class="mc-sticky-atc__price"></div>' +
      '</div>' +
      '<button type="button" class="mc-sticky-atc__btn">Add to Cart</button>';
    document.body.appendChild(bar);

    var barTitle = bar.querySelector('.mc-sticky-atc__title');
    var barPrice = bar.querySelector('.mc-sticky-atc__price');
    var barBtn   = bar.querySelector('.mc-sticky-atc__btn');

    function sync() {
      if (titleEl) barTitle.textContent = titleEl.textContent.trim();
      if (priceEl) barPrice.textContent = priceEl.textContent.trim();
      barBtn.disabled = inlineBtn.disabled;
      barBtn.textContent = inlineBtn.disabled ? 'Sold Out' : 'Add to Cart';
    }
    sync();

    /* Mirror variant changes made by monmouth-pdp.js */
    if ('MutationObserver' in window) {
      new MutationObserver(sync).observe(inlineBtn,
        { attributes: true, childList: true, subtree: true, characterData: true });
      if (priceEl) new MutationObserver(sync).observe(priceEl,
        { childList: true, characterData: true, subtree: true });
    }

    /* Delegate to the real button so all existing logic runs unchanged */
    barBtn.addEventListener('click', function () { inlineBtn.click(); });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        bar.classList.toggle('mc-sticky-atc--visible', !entries[0].isIntersecting);
      }, { rootMargin: '0px 0px -40px 0px' }).observe(inlineBtn);
    } else {
      bar.classList.add('mc-sticky-atc--visible');
    }
  }

  /* ------------------------------------------------------------------------
     5. Mobile account section navigation                          [§5.9]
     Builds a sticky chip strip from the real account nav. Desktop sidebar
     untouched — it is simply hidden by CSS below 1024px.

     Real fix (mobile-gui-fixes-adoption-prompt.md Phase 2) — rewritten
     against the real sections/monmouth-account.liquid. Confirmed real
     structure differs from what this function originally assumed in two
     ways, not just class names:
       1. The container is .acct-layout / .sidebar, not .mc-acct or any
          variant of it — those don't exist anywhere in the real theme.
       2. Nav items are real <button class="sn-item" id="sn-{key}"
          onclick="nav('{key}')"> elements, not <a href="#...">. Clicking
          one calls the real window.nav(key), which swaps which .panel
          has .active (display:none/block) and, on mobile, scrollIntoView
          the panel — it does not simply scroll a long page past several
          simultaneously-visible sections. That structural difference is
          also why the chip's "active" state is synced here with a
          MutationObserver on .sn-item's class list (mirroring whatever
          window.nav() already set) instead of an IntersectionObserver:
          only one .panel is ever in the layout flow at a time, so there
          is nothing for an IntersectionObserver to see transition between
          — .panel-not-active is display:none, not just scrolled past.
     The .sn-item buttons are static Liquid markup present at initial page
     load (confirmed) — unlike the panel *content*, which is filled in
     later by the card-vault.com API call, the nav itself does not need to
     wait for that response.
     --------------------------------------------------------------------- */
  /* Real fix (account-page-figma-mobile-rebuild-prompt.md, 2026-09-14) —
     full rewrite, replacing the 2026-09-11 compact-bar + right-slide-menu
     version (that system is fully superseded, not kept alongside this
     one — the old .mc-acct-mobile-nav / .mc-acct-menu elements are no
     longer built by any code path, so nothing needs a separate teardown).
     Still built from the SAME source data (.sb-nav's real .sn-item
     buttons and .sn-section group labels) — no destinations invented,
     none dropped, no backend logic duplicated:
       1. A fixed dark bottom nav bar: Overview / Orders / Grading pills
          (first three real sidebar items, calling window.nav() directly)
          plus a persistent gold "All N" pill that opens (2).
       2. An "Account Sections" bottom sheet, grouped under the same four
          headings the desktop sidebar already uses, reusing each
          button's real label/icon/onclick key, with a client-side search
          filter, real badge values mirrored (not recomputed) from the
          sidebar's own #sn-grading-count / #sn-vault-badge /
          #sn-credit-badge, active-row highlighting that tracks whichever
          panel is really active, and Sign Out at the bottom calling the
          same real mcSignOut() the desktop hero button already calls.
     Desktop sidebar is untouched; this only ever builds on mobile and
     targets its own new elements. */
  function initAccountNav() {
    if (!isMobile()) return;
    var container = document.querySelector('.acct-layout');
    if (!container || document.querySelector('.mc-bottom-nav')) return;

    var sbNav = container.querySelector('.sidebar .sb-nav');
    var srcButtons = sbNav ? sbNav.querySelectorAll('.sn-item:not(.sn-hidden)') : [];
    if (!srcButtons.length) return;

    /* Walk .sb-nav's children in order, grouping sn-items under whichever
       .sn-section heading precedes them — the same grouping the desktop
       sidebar already renders, just read back out of the DOM instead of
       re-declared. Also capture each item's real badge element id (if
       any) so its live value/visibility can be mirrored, never redrawn
       from a second source. */
    var groups = [];
    var currentGroup = null;
    var totalCount = 0;
    Array.prototype.forEach.call(sbNav.children, function (child) {
      if (child.classList.contains('sn-section')) {
        currentGroup = { title: child.textContent.trim(), items: [] };
        groups.push(currentGroup);
      } else if (child.classList.contains('sn-item') && !child.classList.contains('sn-hidden')) {
        var key = (child.id || '').replace(/^sn-/, '');
        var panel = document.getElementById('panel-' + key);
        if (!key || !panel) return;
        if (!currentGroup) { currentGroup = { title: '', items: [] }; groups.push(currentGroup); }
        var badgeSrc = child.querySelector('.sn-badge');
        currentGroup.items.push({
          key: key,
          panelId: panel.id,
          label: child.querySelector('.sn-icon') ? child.textContent.trim() : child.textContent.trim(),
          iconSvg: child.querySelector('.sn-icon') ? child.querySelector('.sn-icon').outerHTML : '',
          badgeId: badgeSrc ? badgeSrc.id : null,
          button: child
        });
        totalCount++;
      }
    });
    if (!groups.length) return;

    /* ---- 1. Fixed dark bottom nav bar: Overview / Orders / Grading / All N ---- */
    var bottomNav = document.createElement('nav');
    bottomNav.className = 'mc-bottom-nav';
    bottomNav.setAttribute('aria-label', 'Account sections');

    var pillWrap = document.createElement('div');
    pillWrap.className = 'mc-bottom-nav__pills';
    var barKeys = ['overview', 'orders', 'grading'];
    barKeys.forEach(function (key) {
      var found = null;
      groups.forEach(function (g) { g.items.forEach(function (it) { if (it.key === key) found = it; }); });
      if (!found) return;
      var a = document.createElement('a');
      a.className = 'mc-bottom-nav__pill' + (found.button.classList.contains('active') ? ' mc-bottom-nav__pill--active' : '');
      a.href = '#' + found.panelId;
      a.textContent = found.label.replace(/^Orders & Tracking$/, 'Orders').replace(/^Grading Tracker$/, 'Grading');
      a.dataset.mcAcctKey = found.key;
      a.addEventListener('click', function (e) {
        e.preventDefault();
        if (typeof window.nav === 'function') window.nav(found.key);
      });
      pillWrap.appendChild(a);
    });
    bottomNav.appendChild(pillWrap);

    var allBtn = document.createElement('button');
    allBtn.type = 'button';
    allBtn.className = 'mc-bottom-nav__all';
    allBtn.setAttribute('aria-haspopup', 'true');
    allBtn.setAttribute('aria-expanded', 'false');
    allBtn.setAttribute('aria-label', 'Open all account sections');
    allBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/></svg>' +
      '<span>All ' + totalCount + '</span>';
    bottomNav.appendChild(allBtn);
    /* Real fix (account-page-figma-corrections-prompt.md, Fix 1) — Figma's
       outer Background frame (2:15) free-positions its children by
       Y-coordinate, and this bar (Y:174) sits directly under the site
       header, before the dark "Welcome back"/Collector-card zone (Y:242).
       Originally inserted as #acct-authenticated's first child to match
       that Y-order — but DOM order doesn't actually matter for a
       position:fixed element's own visual placement (only its CSS top/
       left/right/z-index do), and nesting it several levels deep inside
       the account section turned out to be exactly the kind of place a
       future ancestor rule (a transform/filter/perspective/will-change/
       contain property — any of which silently turns "fixed relative to
       the viewport" into "fixed relative to that ancestor instead," so
       the bar detaches from the header and drifts with the page instead
       of staying pinned) is easy to introduce without anyone noticing,
       since it wouldn't visibly break anything else on the page.
       account-mobile-tab-bar-sticky-and-overlap-fix-prompt.md — moved to
       a body-level sibling of <main id="main-content"> instead, the same
       "portal" pattern modals/toasts use to guarantee a clean, ancestor-
       proof containing block: <body> and <html> are the only true
       ancestors left, and neither this theme nor a plain page ever puts
       a transform/filter/contain on either of those. Inserted right
       before <main> (not appended to the end of <body>) so tab/focus
       order still reaches it right after the header, same as before. */
    var mainEl = document.getElementById('main-content') || document.querySelector('main');
    if (mainEl && mainEl.parentNode) {
      mainEl.parentNode.insertBefore(bottomNav, mainEl);
    } else {
      document.body.insertBefore(bottomNav, document.body.firstChild);
    }

    /* ---- 2. Account Sections — bottom sheet, same grouped data ---- */
    var overlay = document.createElement('div');
    overlay.className = 'mc-acct-sheet-overlay';
    var sheet = document.createElement('div');
    sheet.className = 'mc-acct-sheet';
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.setAttribute('aria-label', 'Account sections');

    var handle = document.createElement('div');
    handle.className = 'mc-acct-sheet__handle';
    sheet.appendChild(handle);

    var sheetHeader = document.createElement('div');
    sheetHeader.className = 'mc-acct-sheet__header';
    var sheetTitle = document.createElement('span');
    sheetTitle.className = 'mc-acct-sheet__title';
    sheetTitle.textContent = 'Account Sections';
    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'mc-acct-sheet__close';
    closeBtn.setAttribute('aria-label', 'Close account sections');
    closeBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
    sheetHeader.appendChild(sheetTitle);
    sheetHeader.appendChild(closeBtn);
    sheet.appendChild(sheetHeader);

    var searchWrap = document.createElement('div');
    searchWrap.className = 'mc-acct-sheet__search';
    searchWrap.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>';
    var searchInput = document.createElement('input');
    searchInput.type = 'search';
    searchInput.placeholder = 'Search sections';
    searchInput.className = 'mc-acct-sheet__search-input';
    searchWrap.appendChild(searchInput);
    sheet.appendChild(searchWrap);

    var sheetBody = document.createElement('div');
    sheetBody.className = 'mc-acct-sheet__body';
    groups.forEach(function (g) {
      var groupEl = document.createElement('div');
      groupEl.className = 'mc-acct-sheet__group';
      if (g.title) {
        var h = document.createElement('div');
        h.className = 'mc-acct-sheet__group-label';
        h.textContent = g.title;
        groupEl.appendChild(h);
      }
      g.items.forEach(function (it) {
        var row = document.createElement('button');
        row.type = 'button';
        row.className = 'mc-acct-sheet__row';
        row.dataset.mcAcctKey = it.key;
        row.dataset.mcAcctLabel = it.label.toLowerCase();

        var icon = document.createElement('span');
        icon.className = 'mc-acct-sheet__row-icon';
        icon.innerHTML = it.iconSvg;
        row.appendChild(icon);

        var label = document.createElement('span');
        label.className = 'mc-acct-sheet__row-label';
        label.textContent = it.label;
        row.appendChild(label);

        if (it.badgeId) {
          var badge = document.createElement('span');
          badge.className = 'mc-acct-sheet__row-badge mc-acct-sheet__row-badge--' + it.key;
          row.appendChild(badge);
          mirrorBadge(it.badgeId, badge);
        }

        var chev = document.createElement('svg');
        chev.setAttribute('class', 'mc-acct-sheet__row-chev');
        chev.setAttribute('viewBox', '0 0 24 24');
        chev.innerHTML = '<polyline points="20 6 9 17 4 12" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>';
        row.appendChild(chev);

        row.addEventListener('click', function () {
          closeAccountSheet();
          if (typeof window.nav === 'function') window.nav(it.key);
        });
        groupEl.appendChild(row);
      });
      sheetBody.appendChild(groupEl);
    });
    sheet.appendChild(sheetBody);

    /* Sign out — same real mcSignOut() the desktop hero button already
       calls, not a second copy of it. Lives at the bottom of the sheet
       per the brief; removed from the top quick-actions row separately
       (see .mc-hero-signout { display: none } in monmouth-account.css). */
    var signOutBtn = document.createElement('button');
    signOutBtn.type = 'button';
    signOutBtn.className = 'mc-acct-sheet__signout';
    signOutBtn.textContent = 'Sign out';
    signOutBtn.addEventListener('click', function () {
      closeAccountSheet();
      if (typeof window.mcSignOut === 'function') window.mcSignOut();
    });
    sheet.appendChild(signOutBtn);

    document.body.appendChild(overlay);
    document.body.appendChild(sheet);

    /* Search — simple client-side label substring match; hides rows that
       don't match and hides a group's label when none of its rows do. */
    searchInput.addEventListener('input', function () {
      var q = searchInput.value.trim().toLowerCase();
      sheetBody.querySelectorAll('.mc-acct-sheet__group').forEach(function (groupEl) {
        var anyVisible = false;
        var rows = groupEl.querySelectorAll('.mc-acct-sheet__row');
        rows.forEach(function (row) {
          var match = !q || row.dataset.mcAcctLabel.indexOf(q) !== -1;
          row.hidden = !match;
          if (match) anyVisible = true;
        });
        groupEl.hidden = !anyVisible;
      });
    });

    var lastFocus = null;
    function openAccountSheet() {
      lastFocus = document.activeElement;
      overlay.classList.add('mc-acct-sheet-overlay--active');
      sheet.classList.add('mc-acct-sheet--active');
      allBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      searchInput.focus({ preventScroll: true });
    }
    function closeAccountSheet() {
      overlay.classList.remove('mc-acct-sheet-overlay--active');
      sheet.classList.remove('mc-acct-sheet--active');
      allBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      searchInput.value = '';
      sheetBody.querySelectorAll('.mc-acct-sheet__row').forEach(function (row) { row.hidden = false; });
      sheetBody.querySelectorAll('.mc-acct-sheet__group').forEach(function (g) { g.hidden = false; });
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
    allBtn.addEventListener('click', function () {
      sheet.classList.contains('mc-acct-sheet--active') ? closeAccountSheet() : openAccountSheet();
    });
    closeBtn.addEventListener('click', closeAccountSheet);
    overlay.addEventListener('click', closeAccountSheet);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sheet.classList.contains('mc-acct-sheet--active')) closeAccountSheet();
    });

    /* Mirror whichever .sn-item window.nav() has already marked active —
       .panel-not-active is display:none (not just scrolled past), so a
       MutationObserver on the real buttons' class list is the correct
       signal, not an IntersectionObserver. Drives both the bottom bar
       pills and the sheet rows' checkmark/highlight state. */
    function syncActive() {
      var activeBtn = sbNav.querySelector('.sn-item.active');
      var activeKey = activeBtn ? activeBtn.id.replace(/^sn-/, '') : null;
      pillWrap.querySelectorAll('a[data-mc-acct-key]').forEach(function (a) {
        a.classList.toggle('mc-bottom-nav__pill--active', a.dataset.mcAcctKey === activeKey);
      });
      sheetBody.querySelectorAll('.mc-acct-sheet__row[data-mc-acct-key]').forEach(function (r) {
        r.classList.toggle('mc-acct-sheet__row--active', r.dataset.mcAcctKey === activeKey);
      });
    }
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(syncActive);
      srcButtons.forEach(function (btn) {
        mo.observe(btn, { attributes: true, attributeFilter: ['class'] });
      });
    }
  }

  /* Mirrors a real sidebar badge's live text + visibility into a new
     mobile-only element — same "mirror, don't refetch" pattern as the
     other mobile-mirror elements in sections/monmouth-account.liquid
     (pr-name/pr-avatar/pr-email, ov-credit-stat). The source badges
     (#sn-grading-count / #sn-vault-badge / #sn-credit-badge) are already
     kept up to date by real, existing JS elsewhere in the page; this
     only ever reads them. */
  function mirrorBadge(sourceId, targetEl) {
    var source = document.getElementById(sourceId);
    if (!source || !targetEl) return;
    function sync() {
      var hidden = window.getComputedStyle(source).display === 'none' || !source.textContent.trim();
      targetEl.hidden = hidden;
      targetEl.textContent = source.textContent;
    }
    sync();
    if ('MutationObserver' in window) {
      new MutationObserver(sync).observe(source, {
        childList: true, characterData: true, subtree: true,
        attributes: true, attributeFilter: ['style']
      });
    }
  }

  /* ------------------------------------------------------------------------
     6. Applied-filter chips above collection results          [§4.1]
     Reads whatever the filter sheet has checked and renders removable chips.
     --------------------------------------------------------------------- */
  function initAppliedFilterChips() {
    if (!isMobile()) return;
    /* Real fix (mobile-gui-fixes-adoption-prompt.md Phase 2/3) — real
       wrapper is .mc-collection-filterbar, not .mc-filters-bar (see the
       CSS file's section 10 comment for why that name was avoided). */
    var bar = document.querySelector('.mc-collection-filterbar');
    var sheet = document.querySelector('.mc-filter-sheet');
    if (!bar || !sheet) return;
    if (document.querySelector('.mc-applied-filters')) return;

    var wrap = document.createElement('div');
    wrap.className = 'mc-applied-filters';
    wrap.setAttribute('aria-label', 'Applied filters');
    bar.insertAdjacentElement('afterend', wrap);

    function activeFilters() {
      var out = [];
      sheet.querySelectorAll('input[type="checkbox"]:checked').forEach(function (cb) {
        var lbl = cb.closest('label');
        out.push({ label: (lbl ? lbl.textContent : cb.value).trim().slice(0, 40), input: cb });
      });
      sheet.querySelectorAll('a[aria-pressed="true"], .mc-filter-option--active').forEach(function (a) {
        out.push({ label: a.textContent.trim().slice(0, 40), link: a });
      });
      return out;
    }

    function render() {
      var f = activeFilters();
      wrap.innerHTML = '';
      wrap.style.display = f.length ? '' : 'none';
      f.forEach(function (item) {
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'mc-applied-filters__chip';
        chip.innerHTML = item.label + ' <span aria-hidden="true">&times;</span>';
        chip.setAttribute('aria-label', 'Remove filter ' + item.label);
        chip.addEventListener('click', function () {
          if (item.input) { item.input.checked = false; item.input.dispatchEvent(new Event('change', { bubbles: true })); }
          else if (item.link) { item.link.click(); }
          render();
        });
        wrap.appendChild(chip);
      });
      /* Real fix (filter-panel-redesign-prompt.md follow-up) — this used
         to also create/update its own .mc-filter-trigger__count badge on
         the Filters button, a second independent counter alongside the
         real one (.mc-filter-btn__count) sections/monmouth-collection-
         filters.liquid now computes correctly server-side (it wasn't
         reliably computed before — collection.filters alone missed tag-
         based filters like "Great Deal" — so this JS-side count was
         previously the only one that ever actually showed; now that the
         Liquid one is correct, both showing at once rendered as two
         overlapping badges). Removed here; the button's real, correctly-
         computed count/active-state comes from the server-rendered class
         and span, refreshed on every AJAX section swap same as before. */
    }
    render();
    sheet.addEventListener('change', render);
  }

  /* ------------------------------------------------------------------------
     7. Scroll lock that preserves position
     The naive overflow:hidden version jumps the user to the top on close.
     --------------------------------------------------------------------- */
  var savedScroll = 0;
  window.mcLockScroll = function () {
    savedScroll = window.pageYOffset || document.documentElement.scrollTop;
    document.body.style.top = '-' + savedScroll + 'px';
    document.body.classList.add('mc-scroll-locked');
  };
  window.mcUnlockScroll = function () {
    document.body.classList.remove('mc-scroll-locked');
    document.body.style.top = '';
    window.scrollTo(0, savedScroll);
  };

  /* ------------------------------------------------------------------------
     8. Dev-only overflow detector
     Add ?mcdebug=overflow to any URL to outline offending elements and log
     them. Ships inert in production.
     --------------------------------------------------------------------- */
  if (/[?&]mcdebug=overflow/.test(location.search)) {
    window.addEventListener('load', function () {
      var docW = document.documentElement.clientWidth;
      var rows = [];
      document.querySelectorAll('*').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.right > docW + 1 || r.left < -1) {
          el.style.outline = '2px solid red';
          rows.push({
            selector: el.tagName.toLowerCase() +
              (el.id ? '#' + el.id : '') +
              (typeof el.className === 'string' && el.className
                ? '.' + el.className.trim().split(/\s+/).join('.') : ''),
            width: Math.round(r.width),
            overflowsRightBy: Math.round(r.right - docW)
          });
        }
      });
      console.table(rows);
      console.log('scrollWidth', document.documentElement.scrollWidth,
                  'clientWidth', docW,
                  'OVERFLOW', document.documentElement.scrollWidth - docW, 'px');
    });
  }

  function debounce(fn, ms) {
    var t; return function () { clearTimeout(t); t = setTimeout(fn, ms); };
  }

  function initAll() {
    syncHeaderHeight();
    syncCookieBanner();
    initStickyAtc();
    initAccountNav();
    initAppliedFilterChips();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else { initAll(); }

  /* Re-init on breakpoint crossing so rotating a phone works */
  var mq = window.matchMedia(MOBILE);
  (mq.addEventListener ? mq.addEventListener.bind(mq, 'change') : mq.addListener.bind(mq))(function () {
    initAll();
  });
})();
